/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Switch, Typography } from '@material-ui/core';

const SwitchParameter = ({
  form, setForm, parameter, label,
}) => (
  <Grid
    item
    md={12}
    style={{
      display: 'flex', justifyContent: 'flex-start', alignItems: 'center',
    }}
  >
    <Typography
      component="Typography"
      variant="body2"
    >
      {label}
    </Typography>
    <Switch
      checked={form[parameter]}
      onChange={() => { setForm({ ...form, [parameter]: !form[parameter] }); }}
      name="checkRecurent"
      Gridor="primary"
      size="small"
    />
  </Grid>
);

SwitchParameter.propTypes = {
  form: PropTypes.object.isRequired,
  setForm: PropTypes.func.isRequired,
  parameter: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default SwitchParameter;
